<h2 class="title">{{ 'label.label_threshold' | translate }}</h2>
<p class="description">{{ 'label.label_threshold_description' | translate }}</p>

<!-- Native (submit): there is no NgForm/FormGroup directive on this form (a
     single standalone formControl), so (ngSubmit) would never fire. -->
<form (submit)="$event.preventDefault(); submit()">
  <div class="threshold-row">
    <label class="field-label">{{ 'label.threshold_display' | translate | uppercase }}</label>
    <input
      class="ts-input"
      type="number"
      step="0.01"
      [formControl]="thresholdControl"
      data-cy="label-threshold-input"
    />
    <span *ngIf="thresholdControl.invalid && thresholdControl.touched" class="error">
      {{ 'label.invalid_threshold' | translate }}
    </span>
  </div>

  <div class="buttons-row">
    <button type="button" class="btn btn-outline-primary" (click)="cancel()" data-cy="label-threshold-cancel">
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="thresholdControl.invalid"
      data-cy="label-threshold-save"
    >
      <i class="ri-save-line"></i>
      {{ 'button.continue' | translate }}
    </button>
  </div>
</form>
